<app-modal-container i18n-title title="Ups! Vi kan ikke vise dig dette">
  <p i18n>For at se dette skal du acceptere markedsførings-cookies.</p>
  <button (click)="openCookieModal()" class="btn btn-primary right w-100" i18n>Opdater cookie-indstillinger</button>
</app-modal-container>
